<template>
  <v-layout class="pagemargin page" >
    <v-flex>
      <vadmin
        v-if="activeAdmin !== null"
        :admin="component"
        :schema="admin"
      ></vadmin>
      <!--appfooter /-->
    </v-flex>
  </v-layout>
</template>

<script>
import vadmin from "@/components/Admin.vue";
import adminSchema from "@/schemas/admin.json";
import componentSchema from "@/schemas/component.json";
import { mapState } from "vuex";

export default {
  components: {
    vadmin
  },
  props: {
    resource: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    activeAdmin: null,
    admin: null,
    component: null
  }),
  computed: {
    ...mapState({
      // Resources: state => state.Resources
    }),
    queryString() {
      return this.$route.query;
    }
  },
  watch: {
    resource: {
      handler: function() {
        this.ReadResources();
      },
      deep: true
    },
    queryString: {
      handler: function() {
        this.changeActiveAdmin(this.$route.query.component);
      },
      deep: true
    }
  },
  mounted() {
    this.changeActiveAdmin(this.$route.query.component);
    //console.log("this.$route.query.component = " + this.$route.query.component);
  },
  methods: {
    changeActiveAdmin(admin) {
      this.admin = adminSchema[admin]; //default; this.admin becomes an obj with the table column values
      //console.log("this.admin" + JSON.stringify(this.admin, null, 2));
      this.component = componentSchema[admin]; // this.component becomes an obj with the component values
      this.activeAdmin = admin; // admin = collection name
    },
  }
};
</script>

<style scoped></style>
